'use client';

import { forwardRef } from 'react';
import { IconProgressActivity } from '@/features/icons';
import { IconClose, IconSearchNormal } from '@/components/svg-symbols/icons';
import { cn } from '@/utils/cn';
interface SearchInputFieldProps {
  query: string;
  setQuery: (query: string) => void;
  isFetching: boolean;
  placeholder?: string;
  onFocus?: () => void;
  className?: string;
  inputClassName?: string;
  name?: string;
}
const SearchInputField = forwardRef<HTMLInputElement, SearchInputFieldProps>(({
  query,
  setQuery,
  isFetching,
  placeholder = 'جست‌وجو در کالاها، دسته‌بندی‌ها و برندها',
  onFocus,
  className,
  inputClassName,
  name = 'query'
}, ref) => {
  return <div className={cn('relative flex h-11 items-center', className)}>
                <div className='absolute right-0 top-0 flex h-full items-center px-1.5'>
                    <IconSearchNormal className='mr-1 h-6 w-6 text-text-mediumGray' />
                </div>

                <input toolparamdescription='Search keyword for a product, category, or brand' ref={ref} value={query} type='text' autoComplete='off' onFocus={onFocus} placeholder={placeholder} className={cn('h-full w-full rounded border py-2.5 pl-2 pr-10 text-body-14 leading-relaxed outline-none placeholder:text-text-mediumGray', inputClassName)} onChange={e => setQuery(e.target.value.trimStart())} name={name} id='search-input' />

                <div className='absolute left-0 top-0 flex h-full items-center px-1.5'>
                    {isFetching && query.length ? <IconProgressActivity className='mr-1 h-6 w-6 animate-spin text-text-mediumGray' /> : <button type='button' onClick={() => setQuery('')} data-test='clear-result' aria-label='Clear search' className={cn('flex text-text-mediumGray', {
        hidden: !query.length
      })}>
                            <IconClose className='mr-1 h-6 w-6' />
                        </button>}
                </div>
            </div>;
});
SearchInputField.displayName = 'SearchInputField';
export default SearchInputField;